import { extractLink, extractTitle, extractProvider, extractProviderIcon, extractPreview, extractUrlFromIconJsonLd } from '@atlaskit/link-extractors';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { extractIsTrusted } from '../common/meta/extractIsTrusted';
import { extractIsSupportTheming } from '../common/meta/extractIsSupportTheming';
import { prioritiseIcon } from '../common/icon';
const extractEmbedPreview = (jsonLd, platform, iframeUrlType) => {
  const preview = extractPreview(jsonLd, platform, iframeUrlType);
  if (preview && preview.src) {
    return {
      ...preview,
      src: preview.src
    };
  }
};
function generateContext(jsonLd) {
  const provider = extractProvider(jsonLd);
  if (!provider) {
    return undefined;
  }

  // If no icon is supplied, return existing context
  if (!jsonLd.icon) {
    return provider;
  }
  const generator = jsonLd.generator;
  const icon = prioritiseIcon({
    providerId: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' ? generator['@id'] : undefined,
    fileFormatIcon: undefined,
    documentTypeIcon: undefined,
    urlIcon: extractUrlFromIconJsonLd(jsonLd.icon),
    // We still attempt to follow the icon priority function even if no generator (and therefore provider icon) is defined
    providerIcon: generator && typeof generator !== 'string' && generator['@type'] !== 'Link' && extractProviderIcon(generator.icon)
  });
  return {
    ...provider,
    icon: icon ? icon : provider.icon
  };
}
export const extractEmbedProps = (jsonLd, meta, platform, iframeUrlType) => ({
  link: extractLink(jsonLd) || '',
  title: extractTitle(jsonLd),
  context: getBooleanFF('platform.linking-platform.smart-card.standardise-smart-link-icon-behaviour') ? generateContext(jsonLd) : extractProvider(jsonLd),
  preview: extractEmbedPreview(jsonLd, platform, iframeUrlType),
  isTrusted: extractIsTrusted(meta),
  isSupportTheming: extractIsSupportTheming(meta)
});